import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse, IRootState} from "../../../../types";
import {
    deletedRestoreEmployees,
    deleteEmployee,
    setEmployees,
    setEmployeesRestore,
    setEmployeesWork
} from "./employeesSlice";
import {IEmployeeWorkCreate} from "../EmployeesPages/Work/types";


const GetEmployees = createAsyncThunk(
    "get/employees",
    async (_, { rejectWithValue,dispatch,getState }) => {
        try {
            const response = await request.get("/employees");
            const lang = getState() as IRootState

            const defaultLanguage = lang.languages.defaultLanguage
            dispatch(setEmployees({data:response.data,defaultLanguage}));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response?.data?.message || "unexpected_fail");
        }
    }
);


const CreateEmployees = createAsyncThunk(
    "create/employee",
    async (data: FormData, { rejectWithValue }) => {
        try {

            const response = await request.post("/employees", data,{
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response?.data?.message || "unexpected_fail");
        }
    }
);



const EditEmployees = createAsyncThunk(
    "edit/employee",
    async (data: FormData, { rejectWithValue }) => {
        try {
            const response = await request.post("/employees-update", data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response?.data?.message || "unexpected_fail");
        }
    }
);



const DeleteEmployees = createAsyncThunk(
    "delete/employees/",
    async ( id : number, thunkAPI) => {
        try {
            const response = await request.delete(`/employees/${id}`);
            thunkAPI.dispatch(deleteEmployee(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return thunkAPI.rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteEmployees = createAsyncThunk(
    "get/delete/employees",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/employees/deleted-items`);
            dispatch(setEmployeesRestore(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);




const EmployeesInviteByEmail =createAsyncThunk(
    "post/employees/invite/email",
    async (emails:string[],{rejectWithValue})=>{
        try {
          const response = await request.post("/employees-invite", {
              emails
          });
          return response.data;
        }
        catch (error) {
            const typedError = error as IErrorResponse;

            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
)

const GetEmployeesWork = createAsyncThunk(
    "get/employees/Work",
    async (_,{rejectWithValue,dispatch})=>{
        try {
            const response = await request.get("/employees-work");
            dispatch(setEmployeesWork(response.data))
            return response.data;
        }
        catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
)

const CreateEmployeesWork = createAsyncThunk(
    "post/create/employees/work",
    async (data:IEmployeeWorkCreate,{rejectWithValue})=>{
        try {
            const response = await request.post("/employees-work",data);
            return response.data;
        }
        catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
)


const RestoreDeleteEmployees= createAsyncThunk(
    "restore/delete/employees",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/employees/${id}/restore`);
            dispatch(deletedRestoreEmployees(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);





export {
    CreateEmployees,
    GetEmployees,
    DeleteEmployees,
    EmployeesInviteByEmail,
    GetEmployeesWork,
    CreateEmployeesWork,
    GetDeleteEmployees,
    RestoreDeleteEmployees,
    EditEmployees
};
